import requestGetCall from "../requestCall";
import { CREATE_ACCOUNT_FORM } from "../apiConstants";

const setCreateAccountDetails = async (req) => {
    const baseData = {
        endPoint: CREATE_ACCOUNT_FORM,
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
        }
    };
    console.log(baseData,"---",req);
    return requestGetCall(baseData, req);
};
export default setCreateAccountDetails;